import React from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const AdminMainLayout = (props) => {
    return (
       <div className="mainlayout-maindiv">
            <div className="mainlayout-leftdiv">
                <Sidebar />
            </div>
            <div className="mainlayout-rightdiv">
                <div className="mainlayout-navbar">
                    <Navbar title={props?.title} />
                </div>
                <div className="mainpage">
                    {props.children}
                </div>
            </div>
       </div>
    )
}

export default AdminMainLayout